import React from 'react';
import { Text } from '../../../components';
import { useCardLoadingState, skeletonRows } from '../CardLoadingUtils';

import { RMCard } from '../RMCard';
import { useScrollMask } from '../../ScrollMask/useScrollMask';
import classNames from 'classnames';
import { ContentRow } from './ContentRow';

import './TopTenOpportunitiesCard.scss';

const SKELETON_ROW_COUNT = 5;

export const TopTenOpportunitiesCard = ({ title, details = [], className = '', queryState, ...props }) => {
    const { loading, isError } = useCardLoadingState(queryState);
    const topTenRows = loading ? skeletonRows(SKELETON_ROW_COUNT) : details;

    const titleContent = (
        <div className="header-left">
            <Text size="large" color="muted">
                {title}
            </Text>
            {/* TODO: Implement when we have the data available to view Top 10 opportunities in the table */}
            {/* <Text color="primaryBlue" bold>
                See All
                <RightOutlined />
            </Text> */}
        </div>
    );

    const [scrollRef, maskClass] = useScrollMask();

    // const handleOpportunityToggle = (value) => {
    //     console.log('Toggled to:', value);
    // };

    return (
        <RMCard
            className={classNames(className, 'top-ten-opportunities-card')}
            showMoreIcon={false}
            isError={isError}
            {...props}
        >
            <header>
                {titleContent}
                {/* <Segmented options={['VM', 'App']} onChange={handleOpportunityToggle} size="small" shape="round" /> */}
            </header>
            <div ref={scrollRef} className={classNames('top-ten-content-container', maskClass, 'scrollbar-visible')}>
                <ContentRow details={topTenRows} loading={loading} />
            </div>
        </RMCard>
    );
};
